export default "__VITE_ASSET__CkokMQtL__"